import { Link } from 'react-router-dom';
import Header, { HeaderRenderProps } from '../../header';

const HeaderRender = ({ breadcrumbs, lastIdx }: HeaderRenderProps) => (
    <div>
        <div className="breadcrumbs">
            <ul className="breadcrumbs__list">
                <li className="breadcrumbs__item">
                    <a className="breadcrumbs__link" href="/" title="Главная">
                        <span itemProp="name">Главная</span>
                    </a>
                    <svg
                        className="icon"
                        width="12"
                        height="18"
                        viewBox="0 0 12 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 16.37L2 9l8-7.369"
                            stroke="#000"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </li>
                {breadcrumbs.map(({ name, url }, idx) =>
                    idx === lastIdx ? (
                        <li key={url} className="breadcrumbs__item">
                            <span className="breadcrumbs__link" title={name}>
                                <span itemProp="name">{name}</span>
                            </span>
                            <svg
                                className="icon"
                                width="12"
                                height="18"
                                viewBox="0 0 12 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 16.37L2 9l8-7.369"
                                    stroke="#000"
                                    strokeWidth="2"
                                    strokeLinecap="square"
                                />
                            </svg>
                        </li>
                    ) : (
                        <li key={url} className="breadcrumbs__item">
                            <Link to={url} className="breadcrumbs__link" title={name}>
                                <span itemProp="name">{name}</span>
                            </Link>
                            <svg
                                className="icon"
                                width="12"
                                height="18"
                                viewBox="0 0 12 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 16.37L2 9l8-7.369"
                                    stroke="#000"
                                    strokeWidth="2"
                                    strokeLinecap="square"
                                />
                            </svg>
                        </li>
                    )
                )}
            </ul>
        </div>
        <h1 className="catalog__title">{breadcrumbs[lastIdx].name}</h1>
    </div>
);

function NewItkHeader() {
    return <Header render={HeaderRender} />;
}

export default NewItkHeader;
